import {
    Drawer,
    Popover,
    PopoverProps,
    Theme,
    useMediaQuery
} from "@mui/material";

type ResponsivePopoverProps = PopoverProps;

export const ResponsivePopover = (props: ResponsivePopoverProps) => {
    const isScreenSmallerThanSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
    const headerHeight = document.querySelector("header")?.clientHeight || 0;

    return (
        isScreenSmallerThanSm ? (
            <Drawer
                open={props.open}
                onClose={props.onClose}
                anchor="right"
                sx={{
                    "& .MuiDrawer-paper": {
                        top: headerHeight,
                        py: 1,
                        height: `calc(100dvh - ${headerHeight}px)`
                    }
                }}
            >
                {props.children}
            </Drawer>
        ) : (
            <Popover {...props} />
        )
    );
};